export class CassandraClusterResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CassandraClusterResource.attributeTypeMap;
    }
    constructor() {
    }
}
